<div class="fxFlex flex-column-center-center">
  <div
    class="big-circle app-logo flex-column-center-center"
    [@animate]="{ value: '*', params: { delay: '50ms', scale: '0.2' } }"
  >
    <mat-icon class="s-64 s-md-128 mat-accent">chat</mat-icon>
  </div>

  <span
    class="app-title mt-48 mb-8"
    [@animate]="{ value: '*', params: { delay: '100ms', y: '25px' } }"
  >
    Chat App
  </span>

  <span
    class="app-message fx-show-gt-md fx-hide"
    [@animate]="{ value: '*', params: { delay: '200ms', y: '50px' } }"
  >
    {{ 'CHAT.START_HINT' | translate }}
  </span>

  <button mat-raised-button (click)="newConversation()">
    {{ 'CHAT.NEW_CONVERSATION' | translate }}
  </button>

  <!-- Mobile : le sidenav des conversations est fermé et son seul toggler
       vit dans la toolbar d'une conversation ouverte — sans ce bouton,
       impossible d'atteindre la liste depuis l'écran d'accueil. -->
  <button
    mat-button
    color="accent"
    class="mt-16 fx-hide-gt-md"
    fuseMatSidenavToggler="chat-left-sidenav"
  >
    <mat-icon class="s-18 mr-4">forum</mat-icon>
    {{ 'CHAT.VIEW_CONVERSATIONS' | translate }}
  </button>
</div>
